export default __webpack_public_path__ + "static/portrait2-44d38a42de8f67e8471f22732c9ca2a1.jpg";